import { CART, HOME } from "./actionTypes";

export const homePage = () => ({
    type: HOME,
});

export const cartPage = () => ({
    type: CART,
});
